export default __webpack_public_path__ + "static/media/002.078c93b7.jpg";